<template>
  <div class="gs-app gm-segment-subscribe">
    <!-- Loader -->
    <portal to="loaderTarget">
      <div class="absolute bg-grey-100 bg-opacity-50 h-full left-0 top-0 w-full z-99" v-if="isLoading">
        <gd-loader :label="$t('frontend_loading')"/>
      </div>
    </portal>

    <div
      class="gm-segment-subscribe__section flex flex-col w-full bg-white rounded-lg p-4 included-section-wrapper mt-7"
    >
      <div class="gm-segment-subscribe__heading flex flex-col w-1/2 mb-2 px-3">
        <h4 class="font-semibold text-grey-700 included-section-header">
          {{ $t('frontend_groovemail_segment_subscribe_included') }}
        </h4>
      </div>
      <gd-filters
        v-if="fetchedData"
        class="border-grey-100 border rounded-lg p-3 included-section-inner-wrapper"
        :mainCondition="model.include_mainselect"
        :binaryCondition="model.include_condition"
        :binaryConditionData="binaryConditionData"
        :mainConditionData="mainConditionDataIncluded"
        :addbtndisabled="inaddbtndisabled"
        :firstConditionData="firstIncludeConditionData"
        :filterFirstCondition="fetchFirstIncludeCondition"
        :secondConditionData="secondIncludeConditionData"
        :filterSecondCondition="fetchSecondIncludeCondition"
        :selectedFilters="this.model.includesparams"
        @mainConditionChanged="includeMainSelect"
        @createNewFilter="includeAddButton"
        @updateMainCondition="model.include_mainselect = $event"
        @updateBinaryCondition="model.include_condition = $event"
        @updateSelectedFilters="model.includesparams = $event"
        @firstConditionChanged="firstIncludedConditionUpdated"
        @secondConditionChanged="secondIncludedConditionUpdated"
        @deleteFilter="deleteInclude"
      ></gd-filters>
    </div>

    <div
      class="gm-segment-subscribe__section flex flex-col w-full bg-white rounded-lg p-4 mt-8 excluded-section-wrapper"
    >
      <div class="gm-segment-subscribe__heading flex flex-col w-1/2 mb-2 px-3">
        <h4 class="font-semibold text-grey-700 excluded-section-header">
          {{ $t('frontend_groovemail_segment_subscribe_excluded') }}
        </h4>
      </div>
      <gd-filters
        v-if="fetchedData"
        class="border-grey-100 border rounded-lg p-3 excluded-section-inner-wrapper"
        :mainCondition="model.exclude_mainselect"
        :binaryCondition="model.exclude_condition"
        :binaryConditionData="binaryConditionData"
        :mainConditionData="mainConditionDataExcluded"
        :addbtndisabled="exaddbtndisabled"
        :firstConditionData="firstExcludeConditionData"
        :filterFirstCondition="fetchFirstExcludeCondition"
        :secondConditionData="secondExcludeConditionData"
        :filterSecondCondition="fetchSecondExcludeCondition"
        :selectedFilters="this.model.excludesparams"
        @mainConditionChanged="excludeMainSelect"
        @createNewFilter="excludeAddButton"
        @updateMainCondition="model.exclude_mainselect = $event"
        @updateBinaryCondition="model.exclude_condition = $event"
        @updateSelectedFilters="model.excludesparams = $event"
        @firstConditionChanged="firstExcludedConditionUpdated"
        @secondConditionChanged="secondExcludedConditionUpdated"
        @deleteFilter="deleteExclude"
      ></gd-filters>
    </div>

    <div class="gm-segment-subscribe__summary w-full bg-white rounded p-4 mt-8" v-if="source !== 'broadcast'">
      <SegmentStats :statsData="statsData" />
      <div class="mt-8 flex flex-row justify-center">
        <div class="w-1/2 flex flex-row justify-center gap-3">
          <gs-button
            variant="outline"
            @click="showRecord()"
          >
            {{ $t('frontend_groovemail_segment_subscribe_reload') }}
          </gs-button>
          <gs-button
            variant="primary"
            @click="updateSegment()"
          >
            {{ $t('frontend_save_exit') }}
          </gs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import Filters from '@/components/filters.vue';
import SegmentStats from './segment-stats.vue';
import filterMixin from '@/mixin/filterMixin';
import { listUrls, categoryUrl, sequenceUrls, segmentUrls, formUrls, broadcastUrls} from '@/utils/urls.js';
import { putData, getData } from '@/utils/apiHelper.js';
import themeConfig from '@/theme/themeConfig';
import showAlert from '@/components/sweet-alert-popup.js';

// import icons
import UsersIcon from '@/assets/images/icons/new/leads_new.svg';
import MailIcon from '@/assets/images/icons/new/email_new.svg';
import SendIcon from '@/assets/images/icons/new/paper_new.svg';
import ShieldOffIcon from '@/assets/images/icons/new/inactive_new.svg';

export default {
  middleware: 'auth',

  metaInfo() {
    return { title: this.$t('frontend_groovemail_segment_title') };
  },

  props: {
    source: {
      required: false,
      default: 'segment',
    },
    includedConditions: {
      required: false,
    },
    includeType: {
      required: false,
    },
    excludedConditions: {
      required: false,
    },
    excludeType: {
      required: false,
    },
  },

  mixins: [filterMixin],

  data() {
    return {
      fetchedData: false,
      totalsend: 0,
      totalleads: 0,
      filledemails: 0,
      blocked: 0,
      isLoading: false,
    };
  },

  watch: {
    // Sets a watcher on included conditions to check if user can create segment.
    'model.includesparams': function checkIncludedConditions() {
      this.toggleCanCreateSegment();
    },

    // Sets a watcher on excluded conditions to check if user can create segment.
    'model.excludesparams': function checkExcludedConditions() {
      this.toggleCanCreateSegment();
    },
  },


  // Makes API call's and initializes segment data in case of edit.
  async created() {
    // show loader
    this.showLoader();
    
    try {
      this.includemainselectname = this.subscribe_everybody;
      this.excludemainselectname = this.subscribe_everybody;

      if (this.$route.params.id && this.$route.name === 'EditSegement') {
        await this.fetchMailSegment(this.$route?.params?.id);
      }
      this.fetchedData = true;
      this.showRecord();

      // sets include & exclude data if user redirects from broadcast page
      if (this.source === 'broadcast') {
        this.intializeSegmentsDataForBroadcast(); 
      }

      // fetches lists, categories, forms, sequences & broadcast data on page load
      Promise.all([
        getData(listUrls.listOnly).then((response) => {
          this.lists = response?.data?.data;
        }),
        getData(categoryUrl).then((response) => {
          this.categories = response?.data;
        }),
        getData(formUrls.form).then((response) => {
          this.forms = response?.data;
        }),
        getData(sequenceUrls.sequence).then((response) => {
          this.sequences = response?.data;
        }),
        this.fetchBroadcastsData()
      ]);


      // hide loader
      this.hideLoader();

    } catch (error) {
      this.requestErrorAlert(error.response?.data?.error);
    }
  },

  validations: {
    model: {
      include_condition: { required },
      exclude_condition: { required },
      excludesparams: { required },
      includesparams: { required },
    },
  },
  
  methods: {
    // show loader
    showLoader() {
      if (!this.isLoading) {
        this.isLoading = true;
      }
    },

    // hide loader
    hideLoader() {
      if (this.isLoading) {
        this.isLoading = false;
      }
    },


    // error message for the request field
    async requestErrorAlert(error) {
      // hide the loader
      this.hideLoader();
      
      await showAlert({
        iconType: 'alert-error',
        html : `
          <style>.swal2-cancel { color: var(--brand-primary-invert) !important; }</style>
          <p class="text-sm text-deep-dark mb-3">${error || this.$t('frontend_backend_error') }</p>
        `,
        showCancelButton: false,
        showCloseButton: true,
        confirmButtonColor: themeConfig.appPrimaryColor,
        confirmButtonText: this.$t('frontend_close'),
      });
    },

    /**
     * Emits an event enableCreateSegment which allows user to create a segment if include or exclude parameters are added.
     */
    toggleCanCreateSegment() {
      if (
        (this.model.includesparams && this.model.includesparams.length) ||
        (this.model.excludesparams && this.model.excludesparams.length)
      ) {
        this.$emit('enableCreateSegment', true);
      } else {
        this.$emit('enableCreateSegment', false);
      }
    },

    /**
     * Fetches mail segment using id and sets include or exclude condition & parameters.
     * @param {string} id Unique id of a segment.
     */
    async fetchMailSegment(id) {

      // show loader
      this.showLoader();

      try {
        let mailsegment = await getData(`${segmentUrls.segment}/${id}`);
        mailsegment = mailsegment?.data;

        // check if include conditions and include type is null, then set default values
        if (!mailsegment.include_conditions && !mailsegment.include_type) {
          this.model.include_condition = 'AND';
          this.model.includesparams = [];
          this.model.exclude_condition = 'AND';
          this.model.excludesparams = [];
        } else {
          this.model.include_condition = mailsegment?.include_type || 'AND';
          this.model.includesparams = JSON.parse(mailsegment?.include_conditions)
          this.model.exclude_condition = mailsegment?.exclude_type || 'AND';
          this.model.excludesparams = JSON.parse(mailsegment?.exclude_conditions);
        }


        // hide loader
        this.hideLoader();
      } catch (error) {
        this.requestErrorAlert(error.response?.data?.error);
      }
    },

    /**
     * Sets include main select name when include main condition changes.
     * if include main select condition selected is 'all', then enables include add button.
     * else disables include add button
     * @param {object} e contains updated data after change event triggers.
     */
    includeMainSelect(e) {
      this.includemainselectname =
        e.target.options[e.target.options.selectedIndex].dataset.name;
      if (
        this.model.include_mainselect &&
        this.model.include_mainselect === 'all'
      ) {
        this.inaddbtndisabled = false;
      } else {
        this.inaddbtndisabled = true;
      }
      this.includefiltertags = '';
      this.includelinks = '';
    },

    /**
     * Sets exclude main select name when exclude main condition changes.
     * if exclude main select condition selected is 'all', then enables exclude add button.
     * else disables exclude add button
     * @param {object} e contains updated data after change event triggers.
     */
    excludeMainSelect(e) {
      this.excludemainselectname =
        e.target.options[e.target.options.selectedIndex].dataset.name;
      if (
        this.model.exclude_mainselect &&
        this.model.exclude_mainselect === 'all'
      ) {
        this.exaddbtndisabled = false;
      } else {
        this.exaddbtndisabled = true;
      }
      this.excludefiltertags = '';
      this.excludelinks = '';
    },

    // Fetches selected, active, inactive & in the segment count.
    async showRecord() {
      // show loader
      this.showLoader();

      try {
        const { data } = await getData(segmentUrls.getSegmentLeads, {
          params: {
            include_type: this.model.include_condition,
            exclude_type: this.model.exclude_condition,
            include_conditions: this.model.includesparams,
            exclude_conditions: this.model.excludesparams,
          },
        });
        if(data) {
          this.totalleads = data.totalleads;
          this.filledemails = data.filledemails;
          this.blocked = data.blocked;
          this.totalsend = data.totalsend;
        }

        // hide loader
        this.hideLoader();
      } catch (error) {
        this.requestErrorAlert(error.response?.data?.error);
      }
    },

    /**
     * Creates new segment.
     * @param {string} segmentId - unique id of a segment.
     */
    async createNewSegment(segmentId) {
      // show loader
      this.showLoader();

      try {
        let mailsegment = await getData(`${segmentUrls.segment}/${segmentId}`);
        mailsegment = mailsegment?.data;
        mailsegment.include_type = this.model.include_condition;
        mailsegment.include_conditions = JSON.stringify(
          this.model.includesparams
        );
        mailsegment.exclude_type = this.model.exclude_condition;
        mailsegment.exclude_conditions = JSON.stringify(
          this.model.excludesparams
        );
        await putData(`${segmentUrls.segment}/${segmentId}`, mailsegment);

        // hide loader
        this.hideLoader();
      } catch (error) {
        this.requestErrorAlert(error.response?.data?.error);
      }
    },

    // Update Segment
    async updateSegment() {
      // show loader
      this.showLoader();

      try {
        const segmentData = await getData(`${segmentUrls.segment}/${this.$route.params.id}`);
        this.mailsegment = segmentData?.data;
        if(this.mailsegment) {
          this.mailsegment.include_type = this.model.include_condition;
          this.mailsegment.include_conditions = JSON.stringify(
            this.model.includesparams
          );
          this.mailsegment.exclude_type = this.model.exclude_condition;
          this.mailsegment.exclude_conditions = JSON.stringify(
            this.model.excludesparams
          );
        }
        await putData(`${segmentUrls.segment}/${this.mailsegment.id}`, this.mailsegment).then(() => {
          this.$router.push({ name: 'SegmentsLegacy' });
        });

        // hide loader
        this.hideLoader();
      } catch (error) {
        this.requestErrorAlert(error.response?.data?.error);
      }
    },

    /**
     * Returns main condition details.
     * @return {array} - array of objects containing main condition details.
     */
    getConditionData() {
      return [
        {
          value: '',
          dataName: '',
          name: this.$t('frontend_groovemail_segment_select'),
        },
        {
          value: 'all',
          dataName: this.subscribe_everybody,
          name: this.$t('frontend_groovemail_segment_subscribe_everybody'),
        },
        {
          value: 'subscribedlist',
          dataName: 'Subscribed to list',
          name: this.$t('frontend_groovemail_segment_subscribed_tolist'),
        },
        {
          value: 'hastag',
          dataName: 'Has tag',
          name: this.$t('frontend_groovemail_segment_subscribe_hastag'),
        },
        {
          value: 'hasform',
          dataName: 'Has form',
          name: this.$t('frontend_groovemail_lead_listing_filters_has_form'),
        },
        {
          value: 'subscribedsequence',
          dataName: 'Subscribed to sequence',
          name: this.$t('frontend_groovemail_subscribed_to_sequence_filter_option'),
        },
        {
          value: 'hasip',
          dataName: 'Has Ip',
          name: this.$t('frontend_groovemail_leads_filter_has_ip_option'),
        },
        {
          value: 'openbroadcast',
          dataName: 'Opened a Broadcast',
          name: this.$t(
            'frontend_groovemail_leads_filter_opened_a_broadcast_option'
          ),
        },
        {
          value: 'clickbroadcast',
          dataName: 'Clicked a Link',
          name: this.$t(
            'frontend_groovemail_leads_filter_clicked_a_link_option'
          ),
        },
        {
          value: 'indaterange',
          dataName: 'Date range',
          name: this.$t('frontend_groovemail_leads_filter_date_range_option'),
        },
        {
          value: 'hasstatus',
          dataName: 'Status',
          name: this.$t('frontend_groovemail_leads_filter_status_option'),
        },
      ];
    },

    // Fetches campaigns data
    async fetchBroadcastsData() {
      await getData(broadcastUrls.broadcastList).then((response) => {
        this.campaigns = response?.data?.data;
      });
    },

    // Sets include type & condition and exclude type & condition when user redirects from broadcast page.
    intializeSegmentsDataForBroadcast() {
      this.model.include_condition = this.includeType;
      this.model.includesparams = this.includedConditions;
      this.model.exclude_condition = this.excludeType;
      this.model.excludesparams = this.excludedConditions;
    },
  },

  components: {
    'gd-filters': Filters,
    SegmentStats,
  },

  computed: {
    /**
     * Filters included main condition data. Disables other main condition
     * options if included condition is 'Everybody in my database'
     * else disables 'Everybody in my database' main condition option.
     * @return {object} - returns filtered included main conditions.
     */
    mainConditionDataIncluded() {
      const conditionData = this.getConditionData();
      let everyFilter = false;
      if (this.model.includesparams && this.model.includesparams.length) {
        if (this.model.includesparams[0].action === 'all') {
          everyFilter = true;
        }
        if (everyFilter) {
          for (let i = 0; i < conditionData.length; i += 1) {
            conditionData[i].disabled = true;
          }
        } else {
          conditionData[1].disabled = true;
        }
      }
      return conditionData;
    },

    /**
     * Filters excluded main condition data. Disables other main condition options
     * if excluded condition is 'Everybody in my database'
     * else disables 'Everybody in my database' main condition option.
     * @return {object} - returns filtered excluded main conditions.
     */
    mainConditionDataExcluded() {
      const conditionData = this.getConditionData();
      let everyFilter = false;
      if (this.model.excludesparams && this.model.excludesparams.length) {
        if (this.model.excludesparams[0].action === 'all') {
          everyFilter = true;
        }
        if (everyFilter) {
          for (let i = 0; i < conditionData.length; i += 1) {
            conditionData[i].disabled = true;
          }
        } else {
          conditionData[1].disabled = true;
        }
      }
      return conditionData;
    },

    /**
     * Returns segments statistics which include total subscribed contacts, active contacts,
     * inactive contacts & the contacts to whom the action will be executed.
     * @return {array} - returns an array of segments statistics based on conditions applied.
     */
    statsData() {
      return [
        {
          id: 1,
          value: this.totalleads,
          label: this.$t('frontend_groovemail_segment_subscribe_leads'),
          icon: UsersIcon,
        },
        {
          id: 2,
          value: this.filledemails,
          label: this.$t('frontend_groovemail_segment_subscribe_emails'),
          icon: MailIcon,
        },
        {
          id: 3,
          value: this.blocked,
          label: this.$t('frontend_groovemail_segment_subscribe_blocked'),
          icon: ShieldOffIcon,
        },
        {
          id: 4,
          value: this.totalsend,
          label: this.$t('frontend_groovemail_segment_subscribe_total'),
          icon: SendIcon,
        },
      ];
    },
  },
};
</script>
<style>
.disabled {
  cursor: not-allowed;
}
</style>

<style scoped>
.gm-segment-subscribe {
  min-height: 100%;
  padding: 28px;
  color: var(--gs-foreground);
  background: var(--gs-background);
}

.gm-segment-subscribe__section,
.gm-segment-subscribe__summary {
  border: 1px solid var(--gs-border);
  border-radius: var(--gs-radius-lg);
  box-shadow: var(--gs-shadow-sm);
}

@media (max-width: 640px) {
  .gm-segment-subscribe {
    padding: 16px;
  }

  .gm-segment-subscribe__heading {
    width: 100%;
    padding-right: 0;
    padding-left: 0;
  }

  .gm-segment-subscribe__section,
  .gm-segment-subscribe__summary {
    padding: 18px;
    border-radius: var(--gs-radius-md);
  }
}
</style>
